import { useContext, useState, useEffect, useRef } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import { Titulo, Cargando, excepcionVacia, llamarApi, logger } from "./Comun";

import Contexto from "./Contexto";

const ListaTiposSesion = (props) => {
  const parametros = useContext(Contexto);

  const [isLoading, setIsLoading] = useState(true);

  const [resListaTiposSesiones, setResListaTiposSesiones] = useState(null);
  const [idTipoSesionHover, setIdTipoSesionHover] = useState(false);

  const fetchEjecutado = useRef(false);

  const handleChangeIdTipoSesion = (pIdTipoSesion) => {
    if (pIdTipoSesion) {
      props.setIdTipoSesion(pIdTipoSesion);
      props.irAPAso("LHD");
    }
  };

  const mostarDescripcionTipoSesion = (e, descripcion) => {
    e.stopPropagation();

    const element = e.currentTarget;

    // Remove existing popover if already open
    const existing = Popover.getInstance(element);
    if (existing) {
      existing.dispose();
      return;
    }

    const popover = new Popover(element, {
      content: descripcion,
      html: false,
      placement: "right",
      trigger: "focus",
      sanitize: true,
    });

    popover.show();

    // Give focus so clicking elsewhere dismisses it
    element.focus();
  };

  const handleMouseEnter = (e) => {
    setIdTipoSesionHover(e);
  };

  const handleMouseLeave = (e) => {
    setIdTipoSesionHover(null);
  };

  const handleClickOtraSede = () => {
    props.setIdSede(null);
    props.setIdEmpleado(null);
    props.setIdTipoSesion(null);
    props.irAPAso("LS");
  };

  const handleClickOtroEmpleado = () => {
    props.setIdEmpleado(null);
    props.setIdTipoSesion(null);
    props.irAPAso("LE");
  };

  useEffect(() => {
    if (fetchEjecutado.current) return;
    fetchEjecutado.current = true;

    const urlAPI = parametros.urlBaseApis + "lt";

    logger(
      new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        "." +
        new Date().getSeconds() +
        "- Render del lista sesiones"
    );

    llamarApi({
      url: urlAPI,
      jwt: props.jwt,
      method: "GET",
      payload: {
        idSede: props.idSede,
        ...(props.idEmpleado != null && { idEmpleado: props.idEmpleado }),
      },
      onSuccess: (data) => {
        props.setJwt(data.jwt);
        setResListaTiposSesiones(data.arrayTiposSesiones);
        props.setExcepcion(excepcionVacia);
      },
      onError: (err) => props.setExcepcion(err),
      onFinally: () => setIsLoading(false),
    });
  }, [props.idSede, props.idEmpleado]);

  if (isLoading)
    return <Cargando mensaje="Cargando tipos de sesiones ..."></Cargando>;

  return (
    <>
      <Titulo textoTitulo="Selecciona el tipo de sesión que quieres solicitar"></Titulo>
      <Container className="flex-grow-1 d-flex flex-column align-items-center justify-content-center pb-4  px-2">
        <Row className="w-100 justify-content-center align-items-center flex-fill">
          {resListaTiposSesiones.map((tipoSesion, index) => (
            <Col className="mb-3" xs={12} sm={12} md={6} lg={4} key={index}>
              <Card className="shadow-sm">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <Card.Title>{tipoSesion.descripcion}</Card.Title>
                    {tipoSesion.descripcionLarga?.trim() && (
                      <OverlayTrigger
                        trigger="click"
                        placement="auto"
                        rootClose
                        overlay={
                          <Popover
                            id={`popover-${tipoSesion.idTipoSesion}`}
                            className="popover-descripcion-tipo-sesion"
                          >
                            <Popover.Header as="h3">
                              {tipoSesion.descripcion}
                            </Popover.Header>
                            <Popover.Body>
                              {tipoSesion.descripcionLarga}
                            </Popover.Body>
                          </Popover>
                        }
                      >
                        <button
                          type="button"
                          className="btn icon-btn"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <i className="bi bi-info"></i>
                        </button>
                      </OverlayTrigger>
                    )}
                  </div>
                  <Row className="align-items-start pt-2 g-1 text-muted">
                    <Col xs="auto">
                      <i className="bi bi-clock-fill me-2 text-secondary pe-1"></i>
                    </Col>
                    <Col>
                      Duración: {tipoSesion.minutosDuracionDefecto} minutos
                    </Col>
                  </Row>
                  <Row className="align-items-center justify-content-center pt-3 g-1">
                    <Col xs="auto">
                      <div
                        key={tipoSesion.idTipoSesion + "_"}
                        className={`px-2 py-1 rounded text-center horario-disponible fw-semibold cursor-pointer`}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleChangeIdTipoSesion(tipoSesion.idTipoSesion)
                        }
                      >
                        Seleccionar
                      </div>
                    </Col>
                    <Col xs="auto"></Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <Row className="justify-content-center text-center">
          <Col xs={12} sm={12} md={12} lg={12}>
            {parametros.empleadoSeleccionable === 1 ? (
              <Button onClick={handleClickOtroEmpleado} className="px-3 mx-2">
                Seleccionar otro especialista
              </Button>
            ) : (
              ""
            )}
            {parametros.multiSede === 1 ? (
              <Button onClick={handleClickOtraSede} className="px-3 mx-2">
                Seleccionar otra clínica
              </Button>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default ListaTiposSesion;
